import { Menu, MenuItem, MenuProps, Typography } from '@mui/material';
import { FC, MouseEventHandler } from 'react';

type Props = Pick<MenuProps, 'open' | 'anchorEl' | 'onClose'> & {
  items: Array<{
    onclick?: MouseEventHandler<HTMLLIElement>;
    icon?: JSX.Element;
    text: string;
  }>;
};

export const DropdownButtonMenu: FC<Props> = ({ open, anchorEl, onClose, items }) => {
  return (
    <Menu
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      BackdropProps={{
        invisible: true,
        style: { backgroundColor: 'transparent', opacity: '0' }
      }}
      PaperProps={{
        className: 'shadow-500'
      }}
      sx={{
        '& li.MuiMenuItem-root': {
          padding: '0.5rem 1.5rem'
        }
      }}
      elevation={0}
    >
      {items.map((item, index) => (
        <MenuItem key={index} disableRipple onClick={item.onclick}>
          {item.icon && item.icon}
          <Typography sx={{ marginLeft: item.icon ? '1rem' : 0 }}>{item.text}</Typography>
        </MenuItem>
      ))}
    </Menu>
  );
};
